
import StringsUK from 'localization/StringsUK';
import StringsJA from 'localization/StringsJA';
import StringsUS from 'localization/StringsUS';

export default class Strings {
        // initialize with language as input
    static languageCode = 'us';
    static strings = StringsUS; // default to English
    // make a static setter for languagecode to set strings
    static setLanguage(code) {
        switch(code) {
            case 'ja':
                this.strings = StringsJA;
                break;
            case 'uk':
                this.strings = StringsUK;
                break;
            case 'us':
                this.strings = StringsUS;
                break;
            default:
                this.strings = StringsUS;
                break;
        }
    } 
}

